<script>
  export default {
    page() {
      return {
        title: '使用細則＆隱私權條款',
      }
    },
    components: {
      Layout: () => import("@layout/main"),
      SectionContent: () => import("./components/Index/SectionContent"),
    },
  }
</script>
<template>
  <Layout :class="$style.viewPrivacy">
    <div class="header__bg">
      <BaseBannerTitle 
        title="使用細則＆隱私權條款" 
        sub-title="Privacy" 
      />
    </div>
    <SectionContent

    />
  </Layout>
</template>
<style lang="scss" module>
  .viewPrivacy {
    :global {
      .viewPrivacy {
        // @include unstyled;
      }
    }
  }
</style>
